import { SplitFactory } from '@splitsoftware/splitio';

export default class SplitFeatureToggle {
  CONTROL_STATE = 'control';

  TOGGLE_ON = 'on';

  init = ({ businessId }) => {
    const client = SplitFactory({
      core: {
        authorizationKey:  process.env.REACT_APP_SPLIT_API_KEY,
        key: businessId,
      },
      startup: {
        requestTimeoutBeforeReady: 1,
        retriesOnFailureBeforeReady: 2,
        readyTimeout: 1.5,
      },
      storage: {
        type: 'LOCALSTORAGE',
        prefix: 'MYOB-Team',
      },
    }).client();

    return new Promise((resolve) => {
      client.on(client.Event.SDK_READY, () => {
        this.client = client;
        resolve();
      });

      client.on(client.Event.SDK_READY_TIMED_OUT, () => {
        resolve();
      });
    });
  };

  isToggleOn(splitName, splitAttributes) {
    if (this.client) {
      return (
        this.client.getTreatment(splitName, splitAttributes) === this.TOGGLE_ON
      );
    }

    return false;
  }

  reset() {
    if (this.client) {
      this.client.destroy();
      this.client = null;
    }
  }
}
